import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import React from 'react'

const CustomRadio = ({ name = '', value, onChange = () => { }, radioList = [],direction ='column' }) => {
    return (
        <Box className='CustomRadioBtn'>
            <RadioGroup
                name={name}
                value={value}
                onChange={onChange}
                row={direction === 'row'}>
                {radioList.map((obj, index) => (
                    <FormControlLabel key={`${name}-${index}`} value={obj.value} control={<Radio />} label={obj.label} />
                ))}
                
            </RadioGroup>
        </Box>
    )
}

export default CustomRadio